import { reactive } from 'vue'
import { toast } from '@/stores/toast'

/**
 * Envoi de formulaire : désactive le bouton pendant l'appel (double-clic) et
 * rattache les erreurs 422 aux champs du même nom. Une erreur sans `errors`
 * (règle métier, 409, 429…) est affichée telle quelle : `message` est déjà
 * lisible par l'utilisateur.
 */
export function useSubmit() {
  const state = reactive({ submitting: false, message: '', fieldErrors: {} })

  function reset() {
    state.message = ''
    state.fieldErrors = {}
  }

  async function submit(action, { onError } = {}) {
    if (state.submitting) return undefined
    reset()
    state.submitting = true
    try {
      return await action()
    } catch (e) {
      if (onError && onError(e) === true) return undefined
      if (e.status === 422 && e.errors) {
        state.fieldErrors = Object.fromEntries(
          Object.entries(e.errors).map(([field, messages]) => [field, [].concat(messages)])
        )
        state.message = e.message
      } else if (e.name !== 'AbortError') {
        state.message = e.message
      }
      return undefined
    } finally {
      state.submitting = false
    }
  }

  /** Comme submit, mais l'erreur est affichée en toast (actions hors formulaire). */
  async function run(action) {
    if (state.submitting) return undefined
    state.submitting = true
    try {
      return await action()
    } catch (e) {
      toast.error(e.message)
      return undefined
    } finally {
      state.submitting = false
    }
  }

  return { state, submit, run, reset }
}
